import { TrashIcon } from "@heroicons/react/outline";
import { useContext } from "react";

import { useAuth } from "@/context/auth-context";
import { useDeleteDatasetRows } from "@/queries";
import { DatasetEditorContext } from "../..";
import { DropdownMenuVariant } from "@/components/ui/DropdownMenu/types";

export const useDeleteAllRows = () => {
  const authContext = useAuth();
  const userToken = authContext!.userToken;
  const { isDraft, isDeletingDataset, isDeletingDatasetGroup, isRowsEmpty } =
    useContext(DatasetEditorContext);
  const deleteAllRows = useDeleteDatasetRows(userToken!);

  return {
    id: "delete-all-rows",
    label: "Delete All Rows",
    icon: TrashIcon,
    onClick: () => deleteAllRows.mutate(),
    getDisabled: () =>
      isDeletingDataset || isDeletingDatasetGroup || isRowsEmpty || !isDraft,
    shouldShow: isDraft,
    variant: DropdownMenuVariant.DESTRUCTIVE,
    isLoading: deleteAllRows.isLoading,
  };
};
